import { Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FragmentNavigationService } from '../../services/fragment-navigation.service';

export type CtaVariant = 'primary' | 'secondary';

@Component({
  selector: 'app-cta-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './cta-button.component.html',
  styleUrl: './cta-button.component.scss',
  host: {
    '[class.cta-button--inverse]': 'inverse()',
    '[class.cta-button--full-width]': 'fullWidth()',
  },
})
export class CtaButtonComponent {
  private readonly fragmentNav = inject(FragmentNavigationService);

  readonly label = input.required<string>();
  readonly variant = input<CtaVariant>('primary');
  readonly inverse = input(false);
  readonly fullWidth = input(false);
  readonly href = input<string>('');
  readonly fragment = input<string>('');
  readonly icon = input<string>('');
  readonly type = input<'button' | 'submit'>('button');

  readonly clicked = output<void>();

  onClick(): void {
    if (this.href()) {
      window.open(this.href(), '_blank', 'noopener');
    } else if (this.fragment()) {
      this.fragmentNav.navigateToFragment(this.fragment());
    }
    this.clicked.emit();
  }
}
